
import { eolHeaderMixin } from '~/mixins'
import { getEmbeddedUrl } from '~/utils'
export default {
  name: 'HeroVariationsButtons3D',
  mixins: [eolHeaderMixin],
  props: {
    main: {
      type: Object,
      default: () => ({}),
    },
    links: {
      type: Object,
      default: () => ({}),
    },
    buttons: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isMounted: false,
      showVideoModal: false,
      animationsEnd: false,
    }
  },
  computed: {
    relatedLinks() {
      const links = [
        {
          title: this.links?.firstLinkTitle,
          link: this.links?.firstLink,
        },
        {
          title: this.links?.secondLinkTitle,
          link: this.links?.secondLink,
        },
        {
          title: this.links?.thirdLinkTitle,
          link: this.links?.thirdLink,
        },
      ]
      return links.filter((linkItem) => linkItem.link?.length > 0)
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.isMounted = true
    }
  },
  methods: {
    isLinkActive(link = '') {
      if (typeof link !== 'string') return false
      return link.toLowerCase().includes(this.$route.params.slug.toLowerCase())
    },
    getEmbeddedUrl,
  },
}
